import { STATIC_URLS } from 'services/urls';
import './TermsAndConditionsBlock.scss';

export const TermsAndConditionsBlock = () => (
    <div className="TermsAndConditionsBlock">
        By creating an account, you agree to our
        {' '}
        <a
            href={STATIC_URLS.TERMS_AND_CONDITIONS}
            className="TermsAndConditionsBlock__Link"
            target="_blank"
            rel="noopener noreferrer"
        >
            Terms and Conditions
        </a>
        {' and '}
        <a
            href={STATIC_URLS.PRIVACY_POLICY}
            className="TermsAndConditionsBlock__Link"
            target="_blank"
            rel="noopener noreferrer"
        >
            Privacy Policy
        </a>
        .
    </div>
);

export default TermsAndConditionsBlock;
